import React from "react";
import BespokeWizard from "@/components/bespoke/BespokeWizard";
import { BESPOKE_CATEGORIES } from "@/lib/bespokeCategories";
import { UpperBodyIcon, ShoulderTypeIcon, SleeveIcon, PocketIcon } from "@/components/bespoke/ShirtIcons";

const UPPER_BODY_OPTIONS = [
  { key: "athletic", label: "Athletic", help: "Broader shoulders, narrower waist." },
  { key: "average", label: "Average", help: "Balanced, proportionate build." },
  { key: "healthy", label: "Healthy", help: "Fuller through the chest and midsection." },
];
const SHOULDER_OPTIONS = [
  { key: "average", label: "Average", help: "Level shoulder line." },
  { key: "sloping", label: "Sloping", help: "Shoulders angle downward from the neck." },
];
const COLLAR_OPTIONS = [
  { key: "mandarin", label: "Mandarin" },
  { key: "band", label: "Band" },
  { key: "round", label: "Round Neck" },
];
const PLACKET_OPTIONS = [
  { key: "plain", label: "Plain Placket" },
  { key: "embroidered", label: "Embroidered", price: 900 },
  { key: "concealed", label: "Concealed" },
];
const SLEEVE_OPTIONS = [{ key: "full", label: "Full Sleeves" }, { key: "half", label: "Half Sleeves" }];
const LENGTH_OPTIONS = [
  { key: "short", label: "Short (above knee)" },
  { key: "regular", label: "Regular (knee)" },
  { key: "long", label: "Long (below knee)" },
];
const SLIT_OPTIONS = [{ key: "straight", label: "Straight Slit" }, { key: "angled", label: "Angled Slit" }, { key: "none", label: "No Slit" }];
const POCKET_OPTIONS = [{ key: "none", label: "No Pocket" }, { key: "single", label: "Single Pocket" }, { key: "side", label: "Side Pockets" }];

const config = {
  garmentType: "kurta",
  title: "Bespoke Kurta",
  prefix: "kurta",
  guideCaption: "For optimal fit, we recommend measuring from your best-fitting kurta.",
  faqs: BESPOKE_CATEGORIES.kurta.faqs,
  groups: [
    { group: "upper_body_shape", label: "Upper Body Shape *", options: UPPER_BODY_OPTIONS, Icon: UpperBodyIcon, default: "average" },
    { group: "shoulder_type", label: "Shoulder Type *", options: SHOULDER_OPTIONS, Icon: ShoulderTypeIcon, default: "average", cols: "grid-cols-2", maxWidth: "max-w-sm" },
    { group: "kurta_collar", label: "Collar", options: COLLAR_OPTIONS, default: "mandarin", maxWidth: "max-w-xl" },
    { group: "kurta_placket", label: "Placket", options: PLACKET_OPTIONS, default: "plain", maxWidth: "max-w-xl", showPrice: true, addon: true },
    { group: "sleeve", label: "Sleeves", options: SLEEVE_OPTIONS, Icon: SleeveIcon, default: "full", cols: "grid-cols-2", maxWidth: "max-w-sm" },
    { group: "kurta_length", label: "Length", options: LENGTH_OPTIONS, default: "regular", maxWidth: "max-w-xl" },
    { group: "kurta_slit", label: "Side Slit", options: SLIT_OPTIONS, default: "straight", maxWidth: "max-w-xl" },
    { group: "pocket", label: "Pocket", options: POCKET_OPTIONS, Icon: PocketIcon, default: "none", maxWidth: "max-w-xl" },
  ],
  sizes: ["S", "M", "L", "XL", "XXL", "3XL"],
  sizeChart: {
    columns: ["Chest (in)", "Kurta Length (in)", "Sleeves (in)", "Across Shoulder (in)"],
    rows: [
      { size: "S", values: [40, 40, 23, 16.5] },
      { size: "M", values: [42, 41, 23.5, 17] },
      { size: "L", values: [44, 42, 24, 17.5] },
      { size: "XL", values: [46, 43, 24.5, 18] },
      { size: "XXL", values: [48, 44, 25, 18.5] },
      { size: "3XL", values: [50, 45, 25, 19] },
    ],
  },
  measureFields: [
    { key: "body_height", label: "Body Height *", target: "style", required: true },
    { key: "shoulder", label: "Shoulder (in) *", target: "meas", required: true },
    { key: "chest", label: "Chest (in) *", target: "meas", required: true },
    { key: "kurta_length", label: "Kurta Length (in) *", target: "meas", required: true },
    { key: "sleeve", label: "Sleeve Length (in)", target: "meas" },
    { key: "waist", label: "Waist (in)", target: "meas" },
  ],
};

export default function BespokeKurta() {
  return <BespokeWizard config={config} />;
}
